var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"toolbar"}}),_c('div',{attrs:{"id":"editorContainer"}}),_c('input',{staticStyle:{"display":"none"},attrs:{"id":"uploadButton","type":"file","accept":"image/*","value":"选择图片"},on:{"change":_vm.onSelectImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }